import {useResolvedThreads} from './data/use-resolved-threads'
import {ForYouThreadItem} from './shared/ForYouThreadItem'
import {ThreadGroupVariant} from './util/classify-thread'

export function ResolvedComments() {
  const threads = useResolvedThreads()

  return (
    <>
      {threads.map(thread => (
        <ForYouThreadItem thread={thread} key={thread.id} variant={ThreadGroupVariant.Resolved} />
      ))}
    </>
  )
}
